export enum MarlenkaPrintType {
  'Tisk celkový',
  'Tisk popředí'
}